import { Component } from "@angular/core";
import {
  IonicPage,
  LoadingController,
  NavController,
  NavParams,
} from "ionic-angular";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ShopperSocialGroupJoinScanConfirmPage } from "../shopper-social-group-join-scan-confirm/shopper-social-group-join-scan-confirm";
import { Http, RequestOptions, Headers } from "@angular/http";
import { TranslateService } from "@ngx-translate/core";
import { ServiceProvider } from "../../providers/service/service";
import { Storage } from "@ionic/storage";

/**
 * Generated class for the ShopperSocialGroupJoinInputPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-shopper-social-group-join-input",
  templateUrl: "shopper-social-group-join-input.html",
})
export class ShopperSocialGroupJoinInputPage {
  private code: FormGroup;
  theme = 1;
  social_group: "";
  mission_group: "";
  mission_text: "";

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {
    this.code = this.formBuilder.group({
      val: ["", Validators.compose([Validators.required])],
    });
    this.social_group = this.navParams.data.social_group;
    this.mission_group = this.navParams.data.social_mission;
    this.mission_text = this.navParams.data.mission_text;
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
  }

  /** submit code */
  confirm() {
    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    if (!this.code.value.val) {
      this.translateService
        .get("Code must not be empty.")
        .subscribe((value) => {
          this.services.presentToast(value);
        });
      return false;
    } else {
      loader.present();
      this.storage.get("token").then((token) => {
        var link = this.services.URLShopperMissionsJoin; // change link
        var headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", "Bearer " + token);
        const requestOptions = new RequestOptions({ headers: headers });
        this.http
          .post(
            link,
            {
              code: this.code.value.val,
              social_mission: this.mission_group,
              social_group: this.social_group,
            },
            requestOptions
          )
          .map((res) => res.json())
          .subscribe(
            (data) => {
              loader.dismiss();
              this.navCtrl.push(ShopperSocialGroupJoinScanConfirmPage, {
                result: data,
                mission_group: data.mission_group,
                social_group: data.social_group,
                mission_text: this.mission_text,
              });
            },
            (error) => {
              var response = JSON.parse(error._body);
              this.translateService.get(response.message).subscribe((value) => {
                this.services.presentToast(value);
              });
              loader.dismiss();
            }
          );
      });
    }
  }

  backPage() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-social-group-join-input/shopper-social-group-join-input.ts